import * as React from 'react';
import {
    HostedStackedElementContainer,
    DialogWidget,
    DialogType,
    DialogPositioningBehavior,
    ButtonType,
    DialogFooterButtonsWidget } from '@tableau/widgets';
import { Messages } from '../../codegen/Localize';
import { IContentInfo } from '../../ts/models/IContentInfo';

export interface ExtractDraftAvaliableDialogProps {
    confirmContinue: () => void;
    confirmDiscard: () => void;
    close: () => void;
}

export class ExtractDraftAvaliableDialog extends React.Component<ExtractDraftAvaliableDialogProps> {
    public static async open(): Promise<boolean> {
        return new Promise((resolve, reject) => {
          const hostContainer = new HostedStackedElementContainer();
          const close = () => {
            hostContainer && hostContainer.remove();
          };
          const props: ExtractDraftAvaliableDialogProps = {

            close,
            confirmContinue: () => {
                close();
                resolve(true);
            },
            confirmDiscard: () => {
                close();
                resolve(false);
            }
          };
          const dialog = React.createElement(ExtractDraftAvaliableDialog, props);
          hostContainer.render(dialog);
        });
    }

    public renderFooter(): React.ReactNode {
    return <DialogFooterButtonsWidget
        buttons={[
        {
            handleClick: () =>  this.props.confirmContinue(),
            buttonType: ButtonType.Go,
            children: Messages.editWorkbookExtractDraftDialogContinue(),
            testId: 'continue-with-extract-draft'
        },
        {
            handleClick: () => this.props.confirmDiscard(),
            buttonType: ButtonType.Go,
            children: Messages.editWorkbookExtractDraftDialogDiscard(),
            testId: 'discard-with-extract-draft',
        },
        {
            handleClick: () => this.props.close(),
            buttonType: ButtonType.Outline,
            children: Messages.close(),
            testId: 'extract-draft-close-dialog',
        },
        ]}
        testId="extract-draft-avaliable-dialog-footer"
    />;
    }

    public render(): React.ReactNode {
        return <DialogWidget
            testId="extract-draft-avaliable"
            type={DialogType.NormalWithTitleBar}
            title={Messages.editWorkbookExtractDraftDialogTitle()}
            onCloseRequest={this.props.close}
            showCloseButton={true}
            positioningBehavior={DialogPositioningBehavior.Centered}
            isModal={true}
            showFooter={true}
            handleGlassClick={this.props.close}
            isGlassTransparent={false}
            footerContent={this.renderFooter()}
            children={Messages.editWorkbookExtractDraftDialogContent()}
            dialogWidth={600}
        />;
    }
}
